export function validate_letters(event) {
  if (!/^[a-zA-Z ]$/.test(event.key)) {
    event.preventDefault();
  }
}

export function validate_numbers(event) {
  if (!/^[0-9 ]$/.test(event.key)) {
    event.preventDefault();
  }
}

export function validate_email(email) {
  var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

export function validate_phone_number(phone_number) {
  const cleaned = phone_number.replace(/\D/g, '');
  return cleaned.length === 10;
}

export function validate_no_special(event) {
  var regex = /^[a-zA-Z0-9 ]$/;
  if (!regex.test(event.key)) {
    event.preventDefault();
  }
}

export function validate_non_empty_string(text_to_test) {
  if (typeof text_to_test !== "string" || text_to_test.trim() === "") {
    return false;
  }
  return true;
}

export function validate_non_sub_zero_number(number_to_test) {
  if (!Number.isInteger(number_to_test) || number_to_test <= 0) {
    return false;
  }
  return true;
}

export function validate_file(file) {
  const MAX_FILE_SIZE = 5 * 1024 * 1024;
  if (!file) {
    return { valid: false, error: "No file selected." };
  }
  if (file.size > MAX_FILE_SIZE) {
    return { valid: false, error: "File must not be larger than 5MB." };
  }
  if (file.type === "application/pdf") {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const arr = new Uint8Array(e.target.result);
        const header = Array.from(arr)
          .map((byte) => String.fromCharCode(byte))
          .join("");

        const is_protected =
          header.includes("/Encrypt") ||
          header.includes("/Encryption") ||
          header.includes("/AuthEvent") ||
          header.includes("/Standard") ||
          header.includes("/CFM") ||
          header.includes("/StrF") ||
          header.includes("/StmF");

        if (is_protected) {
          resolve({
            valid: false,
            error:
              "Password-protected PDFs are not allowed. Please upload an unsecured PDF.",
          });
        } else {
          resolve({ valid: true, error: null });
        }
      };
      reader.onerror = () =>
        resolve({ valid: false, error: "Error reading file." });
      reader.readAsArrayBuffer(file);
    });
  }
  return { valid: true, error: null };
}

export function validate_password(password) {
  const validation = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  const errors = [];

  if (!validation.length) {
    errors.push("Password must be at least 8 characters long");
  }
  if (!validation.uppercase) {
    errors.push("Password must contain at least one uppercase letter");
  }
  if (!validation.lowercase) {
    errors.push("Password must contain at least one lowercase letter");
  }
  if (!validation.number) {
    errors.push("Password must contain at least one number");
  }
  if (!validation.special) {
    errors.push("Password must contain at least one special character");
  }

  const result = {
    isValid: errors.length === 0,
    validation,
    errors,
  };

  return result
}

export function get_error_message(error) {
  const details = error.response?.data?.details;
  const message = error.response?.data?.message;

  if (details) {
    if (Array.isArray(details)) return details.join(', ');
    if (typeof details === 'string') {
      return details.replace(/^\['|'\]$/g, '').trim();
    }
    return String(details);
  }

  if (message) return message;

  return error.message || 'Something went wrong. Please try again.';
}